export type Section = {
  title: string;
  key: string;
};

export const sections: Section[] = [
  { title: "General", key: "general" },
  { title: "1. Introduction", key: "introduction" },
  { title: "2. RACI", key: "raci" },
  {
    title: "3. Scope & Boundary Limits",
    key: "scope-boundary-limits",
  },
  {
    title: "4. Asset Information",
    key: "asset-information",
  },
  {
    title: "5. Asset Management Plan",
    key: "asset-management-plan",
  },
  {
    title: "6. Service Levels & KPI's",
    key: "service-levels-kpis",
  },
  {
    title: "7. Life Cycle Cost Modelling",
    key: "life-cycle-cost-modelling",
  },
  {
    title: "8. Improvement Actions",
    key: "improvement-actions",
  },
];
